export interface OpeningProgress {
  step: number;
  collapsed: boolean;
  skipped: boolean;
}

export const openingKey = (accountId: string): string => `zend.opening.v1.${accountId}`;
const memory = new Map<string, OpeningProgress>();

export function readOpening(
  accountId: string,
  storage: Pick<Storage, "getItem"> | null,
): OpeningProgress | null {
  try {
    const raw: unknown = JSON.parse(storage?.getItem(openingKey(accountId)) ?? "null");
    if (
      raw &&
      typeof raw === "object" &&
      "step" in raw &&
      "collapsed" in raw &&
      "skipped" in raw &&
      Number.isInteger(raw.step) &&
      Number(raw.step) >= 0 &&
      Number(raw.step) <= LAST_STEP + 1 &&
      typeof raw.collapsed === "boolean" &&
      typeof raw.skipped === "boolean"
    )
      return raw as OpeningProgress;
  } catch {
    /* Private storage or damaged local progress must never block the game/API. */
  }
  return memory.get(accountId) ?? null;
}

export function saveOpening(
  accountId: string,
  progress: OpeningProgress,
  storage: Pick<Storage, "setItem"> | null,
): void {
  memory.set(accountId, progress);
  try {
    storage?.setItem(openingKey(accountId), JSON.stringify(progress));
  } catch {
    /* Session-only progress remains usable. */
  }
}

/** The last guided step; finishing it closes the introduction and pays its reward. */
export const LAST_STEP = 7;

/** The first three steps introduce naming, the scene and constructing the Workshop. */
export function canSkipOpening(progress: OpeningProgress): boolean {
  return progress.step >= 3;
}
